import api from 'api'

export interface AiEvaluationOption {
  label: string
  order: number
  correct: boolean
}

export interface AiEvaluationQuestion {
  clientId?: string
  name: string
  order: number
  sourceBlockIndex?: number
  sourceBlockTitle?: string
  options: AiEvaluationOption[]
  regenerating?: boolean
}

export interface AiEvaluationPreviewMeta {
  blockCount: number
  contentWarning?: string | null
  suggestedName?: string | null
  suggestedDescription?: string | null
}

export interface AiEvaluationPreviewResponse {
  questions: AiEvaluationQuestion[]
  meta?: AiEvaluationPreviewMeta
}

export interface AiEvaluationPreviewParams {
  questionCount?: number
  excludeQuestions?: string[]
}

export const previewAiEvaluation = (
  lessonId: number | string,
  params: AiEvaluationPreviewParams = {}
) =>
  api.post<AiEvaluationPreviewResponse>(
    `administration/lessons/${lessonId}/ai_evaluation/preview`,
    {
      aiEvaluation: {
        questionCount: params.questionCount ?? 5,
        ...(params.excludeQuestions?.length
          ? { excludeQuestions: params.excludeQuestions }
          : {}),
      },
    }
  )
